export const StatusOptions = () => [
  { value: '', label: 'All' },
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
  { value: 'Deferred', label: 'Deferred' },
  { value: 'Cancelled', label: 'Cancelled' },
  { value: 'Delinquent', label: 'Delinquent' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Assigned', label: 'Assigned' },
  { value: 'Transferred', label: 'Transferred' },
  { value: 'Resigned', label: 'Resigned' },
  { value: 'Expelled', label: 'Expelled' },
  { value: 'Suspended', label: 'Suspended' },
  { value: 'Stop Billing', label: 'Stop Billing' },
  { value: 'Leave Of Absence', label: 'Leave Of Absence' },
  { value: 'For Legal', label: 'For Legal' },
];

export const ClassOptions = () => [
  { value: 'Class A', label: 'Class A' },
  { value: 'Class B', label: 'Class B' },
  { value: 'Class C', label: 'Class C' },
  { value: 'Founding Members', label: 'Founding Members' },
  { value: 'Honorary Members', label: 'Honorary Members' },
  { value: 'Lot Buyer', label: 'Lot Buyer' },
  { value: 'Assignee Members A', label: 'Assignee Members A' },
  { value: 'Assignee Members B', label: 'Assignee Members B' },
  { value: 'Assignee Members C', label: 'Assignee Members C' },
];

// Recurring transaction choices shared by transaction setup and billing review.
export const RecurringTransactionOptions = () => [
  { value: 'monthly_maintenance', label: 'Maintenance Fee' },
  { value: 'annual_registration_fee', label: 'Annual Registration Fee' },
  { value: 'jun_golf', label: 'Jun Golf Fund' },
  { value: 'golf_parking', label: 'Golf Parking' },
  { value: 'locker', label: 'Locker' },
  { value: 'handicap', label: 'Handicap' },
  { value: 'christmas_contribution', label: 'Christmas Contribution' },
  { value: 'over_due', label: 'Over Due' },
  { value: 'others_recurring', label: 'Others Recurring' },
];

export const TAB_KEYS = {
  PROSHOP: 'proshop',
  FNB: 'fnb',
  SPORTS: 'sports',
};

export const TRANSACTION_TABS = [
  { key: TAB_KEYS.PROSHOP, label: 'Pro Shop', store: 'PROSHOP' },
  { key: TAB_KEYS.FNB, label: 'F&B', store: 'FNB' },
  { key: TAB_KEYS.SPORTS, label: 'Sports Transaction', store: 'SPORTS' },
];
